

export interface IChair {
  x: number;
  y: number;
  angle: number;
  tableAngle?: number;
  colorDark?: number;
  bgClr?: number;
  pivot?: boolean
}


/**
 * CAREFUL: These value will influence the physical dimensions of the tables.
 * Constant original values match design dimensions in figma.
 * Scale is used to keep tables sizes same as floorplan designer, while maintaining figma design proportions.
 * Scale is needed to ensure structures fit in correct positions.
 */

export const DESIGN_SCALE = 0.7
export const CHAIR_W = 56 * DESIGN_SCALE;
export const CHAIR_H = 16 * DESIGN_SCALE;
export const CHAIR_BORDER_RADIUS = 8 * DESIGN_SCALE;
export const CHAIR_EDGE = 36 * DESIGN_SCALE;
export const CHAIR_GAP = 24 * DESIGN_SCALE;
